import type React from 'react';
import { ForgotPasswordStage, LoginStage, ResetPasswordStage, SuccessStage } from '@/components/molecules';
import type { LoginPageProps } from './LoginPage.types';
import { LoginStage as LoginStageEnum, useLogin } from './useLogin';

export const LoginPage: React.FC<LoginPageProps> = ({ setIsLoggedIn, setLoading, loading }) => {
  const { stage, setStage, error, setError, handleLogin, handleSendCode, handleResetPassword } = useLogin({
    setIsLoggedIn,
    setLoading,
    loading,
  });

  const stageRenderers: Record<LoginStageEnum, React.ReactElement> = {
    [LoginStageEnum.LOGIN]: (
      <LoginStage
        onSubmit={handleLogin}
        error={error}
        loading={loading || false}
        onForgotPassword={() => setStage(LoginStageEnum.FORGOT_PASSWORD)}
      />
    ),
    [LoginStageEnum.FORGOT_PASSWORD]: (
      <ForgotPasswordStage
        onSubmit={handleSendCode}
        onReturn={() => {
          setStage(LoginStageEnum.LOGIN);
          setError(false);
        }}
      />
    ),
    [LoginStageEnum.RESET_PASSWORD]: (
      <ResetPasswordStage
        onSubmit={handleResetPassword}
        error={error}
        onReturn={() => {
          setStage(LoginStageEnum.FORGOT_PASSWORD);
          setError(false);
        }}
      />
    ),
    [LoginStageEnum.SUCCESS]: (
      <SuccessStage
        onLogin={() => {
          setStage(LoginStageEnum.LOGIN);
          setError(false);
        }}
      />
    ),
  };

  return stageRenderers[stage] ?? null;
};
